// extracted by mini-css-extract-plugin
module.exports = {"LoadContainer":"Spinner__LoadContainer__KBhqe","Text":"Spinner__Text__1u_ff","Loader":"Spinner__Loader__1DDwY","load1":"Spinner__load1__3Y-9z"};